import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";

const GeoGoal = ({
    account_id,
    org_id,
    geo_id,
    goalDesc,
    setGoalDesc,
    saveGoalGeo,
    loadingSave,
    setLoadingSave,
    errorMessage,
    setErrorMessage
}) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const maxLenghtGoal = 500

    const navigateBack = () => {
        setLoadingSave(false)
        setErrorMessage({ message: "", display: false });
        navigate(`/console/organizations/${org_id}/geo/${geo_id}/context`);
    };

    return (
        <div className="geo_context_cont">
            <p className="add_new_source_cont_title fade-in">
                {t.geo.define_goal_title}
            </p>

            <p className="add_new_source_cont_desc fade-in">
                {t.geo.define_goal_description}
            </p>

            <div className="geo_context_choise_container">
                <div className="geo_goal_cont fade-in">
                    <textarea
                        className="geo_goal_cont_textarea"
                        placeholder={t.geo.goal_placeholder}
                        value={goalDesc}
                        maxLength={maxLenghtGoal}
                        onChange={(e) => setGoalDesc(e.target.value)}
                    />
                    <p className="geo_goal_cont_count">{goalDesc.length}/{maxLenghtGoal}</p>
                </div>

                <p className="warning_source_message fade-in">
                    {t.geo.goal_explain}
                </p>

                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="open_frame_body_footer">
                    <button
                        type="button"
                        className="modale_save_btn fade-in"
                        onClick={navigateBack}
                    >
                        <i className="fa-solid fa-chevron-left"></i>
                        {t.back}
                    </button>
                    {goalDesc && (
                        <button
                            type="button"
                            className="modale_save_btn fade-in"
                            onClick={saveGoalGeo}
                        >
                            {loadingSave ? (
                                <Spinner loading={loadingSave} />
                            ) : (
                                <>
                                    {t.next}
                                    <i className="fa-solid fa-chevron-right"></i>
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default GeoGoal